import { Label } from "components";
import React, { FC } from "react";
import constants from "utils/constants";
import formatDollar from "utils/formatDollar";
import { usePropertyContext } from "../context";
import { useExemptionsContext } from "../ExemptionsContext";

const AppealFlowSavingsEstimateCard: FC<{
	horizontal?: boolean;
	isRetroEligible: boolean | undefined;
}> = ({ horizontal, isRetroEligible }) => {
	const { details, satelliteUrlCss } = usePropertyContext();
	const { flowId, retroSavingsAmount } = useExemptionsContext();

	const averageFirstYearSavings = React.useMemo(() => {
		if (flowId === "NEW_YORK_EXEMPTION") {
			return constants.EXEMPTIONS_NY_AVERAGE_FIRST_YEAR_SAVINGS;
		}

		if (flowId === "FLORIDA_EXEMPTION") {
			return constants.EXEMPTIONS_FL_AVERAGE_FIRST_YEAR_SAVINGS;
		}

		if (flowId === "MICHIGAN_EXEMPTION") {
			return constants.EXEMPTIONS_MI_AVERAGE_FIRST_YEAR_SAVINGS;
		}

		if (flowId === "PENNSYLVANIA_EXEMPTION") {
			return constants.EXEMPTIONS_PA_AVERAGE_FIRST_YEAR_SAVINGS;
		}

		return constants.EXEMPTIONS_AVERAGE_SAVINGS;
	}, [flowId]);

	return (
		<div
			className={"appeal-savings-box" + (horizontal ? "-horizontal" : "")}
			id="exemptions-agreement-page-estimate-card">
			<div
				className="appeal-savings-box-left"
				style={{
					backgroundImage: "url(/savings-map.jpg)",
				}}>
				<div
					id="appeal-sattelite-img"
					style={{
						background: satelliteUrlCss,
					}}
				/>
			</div>
			<div className="appeal-savings-box-right">
				<span className="appeal-savings-box-estimated-savings">
					<Label className={`appeal-savings-box-label`}>
						{isRetroEligible ? (
							<>
								<span>Potential</span>
								<span>Retro</span>
								<span>Refund</span>
							</>
						) : (
							<>
								<span>Average</span>
								<span>First&nbsp;Year</span>
								<span>Savings</span>
							</>
						)}
					</Label>
					<h1 className="color-azure appeal-savings-box-form-flow-savings-amt no-translate display2">
						{isRetroEligible && retroSavingsAmount
							? formatDollar(retroSavingsAmount)
							: averageFirstYearSavings}
					</h1>
				</span>
				<div className="appeal-savings-box-hr appeal-savings-box-hide-on-mobile" />
				<p className="appeal-savings-box-address appeal-savings-box-hide-on-mobile no-translate">
					{details?.address}
					{details?.address2 && " " + details.address2}
					<br />
					{details?.city}, {details?.state} {details?.zip_code}
				</p>
			</div>
		</div>
	);
};

export default AppealFlowSavingsEstimateCard;
